import { render, staticRenderFns } from "./DownloadChart.vue?vue&type=template&id=65872d36"
import script from "./DownloadChart.vue?vue&type=script&lang=js"
export * from "./DownloadChart.vue?vue&type=script&lang=js"
import style0 from "./DownloadChart.vue?vue&type=style&index=0&id=65872d36&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65872d36')) {
      api.createRecord('65872d36', component.options)
    } else {
      api.reload('65872d36', component.options)
    }
    module.hot.accept("./DownloadChart.vue?vue&type=template&id=65872d36", function () {
      api.rerender('65872d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DownloadChart.vue"
export default component.exports